import React, { useEffect, useState } from "react";
import { getApiCall } from "../../service/httpCall";
import { API_DASHBOARD_STATS } from "../../service/url";
import { USER_ROLES } from "../../utilities/constant";
import Loader from "../../components/partials/components/loader";
import { toast } from "react-toastify";
import AsyncStorage from "@react-native-async-storage/async-storage";
import {
  FaUserShield,
  FaBuilding,
  FaUserTie,
  FaUserFriends,
  FaBullhorn,
  FaCalendarAlt,
  FaUsers,
  FaPhoneAlt,
  FaUserPlus,
} from "react-icons/fa";

const DashboardUsersCampCount = () => {
  const [dashboardStats, setDashboardStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [loggedInUserRole, setLoggedInUserRole] = useState(null);

  useEffect(() => {
    async function checkUserRole() {
      const rawUser = await AsyncStorage.getItem("user");
      if (!rawUser) {
        console.error("User not found in AsyncStorage");
        return null; // or handle as needed
      }

      let user;
      try {
        user = JSON.parse(rawUser);
      } catch (e) {
        console.error("Invalid JSON in user from AsyncStorage", e);
        return null;
      }
      if (user.role) {
        setLoggedInUserRole(user.role);
      }
      if (user.role === USER_ROLES.SUPERADMIN) setIsSuperAdmin(true);
    }
    checkUserRole();
  }, []);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const res = await getApiCall(API_DASHBOARD_STATS);
      setDashboardStats(res);
      setLoading(false);
    } catch (error) {
      toast.error(error?.message || "Error Fetching Dashboard Stats");
    }
  };

  useEffect(() => {
    if (!loggedInUserRole) return;
    if (loggedInUserRole == USER_ROLES.CALL_CENTRE_AGENT) {
      return;
    }
    fetchDashboardData();
  }, [loggedInUserRole]);

  if (loading) return <Loader />;

  return (
    <>
      <div className="dashboard-container" style={{ marginBottom: "30px" }}>
        <div className="dashboard-grid">
          {isSuperAdmin && (
            <DashboardCard
              title="Total Sub Super Admin"
              value={dashboardStats?.users?.subSuperAdmin || "0"}
              icon={<FaUserShield />}
              color="purple"
            />
          )}

          {loggedInUserRole !== USER_ROLES.COMPANY_ADMIN &&
            loggedInUserRole !== USER_ROLES.CALL_CENTRE_ADMIN &&
            loggedInUserRole !== USER_ROLES.CALL_CENTRE_AGENT &&
            loggedInUserRole !== USER_ROLES.CALL_CENTRE_TEAM_LEAD && (
              <DashboardCard
                title="Total Resellers"
                value={dashboardStats?.users?.reseller || "0"}
                icon={<FaUsers />}
                color="blue"
              />
            )}

          {loggedInUserRole !== USER_ROLES.CALL_CENTRE_ADMIN &&
            loggedInUserRole !== USER_ROLES.CALL_CENTRE_AGENT &&
            loggedInUserRole !== USER_ROLES.CALL_CENTRE_TEAM_LEAD && (
              <DashboardCard
                title="Total Company (User)"
                value={dashboardStats?.users?.companyAdmin || "0"}
                icon={<FaBuilding />}
                color="orange"
              />
            )}

          {loggedInUserRole !== USER_ROLES.CALL_CENTRE_AGENT &&
            loggedInUserRole !== USER_ROLES.CALL_CENTRE_TEAM_LEAD && (
              <DashboardCard
                title="Total Call Centre (User)"
                value={dashboardStats?.users?.callCentreAdmin || "0"}
                icon={<FaUserTie />}
                color="teal"
              />
            )}

          {loggedInUserRole !== USER_ROLES.CALL_CENTRE_ADMIN && (
            <DashboardCard
              title="Total Team Leads"
              value={dashboardStats?.users?.callCentreTeamLead || "0"}
              icon={<FaUserFriends />}
              color="pink"
            />
          )}

          <DashboardCard
            title="Total Agents"
            value={dashboardStats?.users?.callCentreAgent || "0"}
            icon={<FaPhoneAlt />}
            color="green"
          />

          <DashboardCard
            title="Total Users (All)"
            value={dashboardStats?.users?.totalUsers || "0"}
            icon={<FaUsers />}
            color="dark-blue"
          />

          <DashboardCard
            title="Total Outbound Campaigns"
            value={dashboardStats?.campaigns?.totalCampaigns || "0"}
            icon={<FaBullhorn />}
            color="red"
          />

          <DashboardCard
            title="New Users This Month"
            value={dashboardStats?.users?.totalUsersThisMonth || "0"}
            icon={<FaUserPlus />}
            highlightValue
            color="success"
          />

          <DashboardCard
            title="Outbound Camp This Month"
            value={dashboardStats?.campaigns?.totalCampaignsThisMonth || "0"}
            icon={<FaCalendarAlt />}
            highlightValue
            color="warning"
          />
        </div>
      </div>
    </>
  );
};

const DashboardCard = ({
  title,
  value,
  icon,
  highlightValue = false,
  color = "blue",
}) => {
  return (
    <div className={`dashboard-card ${color}`}>
      <div className="card-icon-wrapper">{icon}</div>

      <div className="card-content">
        <p className="card-title">{title}</p>
        <h2 className={`card-value ${highlightValue ? "highlight" : ""}`}>
          {value}
        </h2>
      </div>
    </div>
  );
};

export default DashboardUsersCampCount;
